export default "__VITE_ASSET__BPDcW9TQ__"